<template>
  <div class="pt-4 px-0">
    <template v-if="tasks.length > 0 && !loading">
      <template >
        <v-row>
          <div
            v-for="(task, i) in tasks"
            :key="i"
            style="padding: 12px; width: 378px;"
          >
            <TaskCard :task="task" :key="i" />
          </div>
        </v-row>
          
      </template>
      <!-- 
      <v-row no-gutters class="roma-pagination mb-3 d-none d-md-block">
        <div class="d-flex wrapper align-center justify-end">
          <Pagination
            :pages="getTasks.totalPages ? getTasks.totalPages : 1"
            :getData="actionGetTasks"
          />
        </div>
      </v-row>
      -->
      <v-row class="roma-pagination d-flex  align-center justify-end">
        <v-pagination
          color="#743085"
          v-model="pageCurrent"
          :length="getTasks.totalPages ? getTasks.totalPages : 1"
          total-visible="5"
        />
      </v-row>
    </template>
    <template v-if="tasks.length == 0 && !loading">
      <div class="px-3">
        <v-row>
            <v-col cols="12" class="d-flex align-items-center info-box parrafo-2">
          <v-icon color="#D8D7D9" class="mr-2">mdi-information-outline</v-icon>  No se han encontrado tareas
        </v-col>
        </v-row>
      </div>
    </template>
    <div class="d-flex justify-content-center pt-5" v-if="loading">
        <v-progress-circular indeterminate color="#743085"></v-progress-circular>
        <v-progress-circular class="mx-2" indeterminate color="#E67F24"></v-progress-circular>
        <v-progress-circular class="mr-2" indeterminate color="#389CC3"></v-progress-circular>
        <v-progress-circular indeterminate color="#FADF2C"></v-progress-circular>
    </div>
  </div>
</template>

<script>
import TaskCard from "./TaskCard.vue";
import { mapActions, mapGetters } from "vuex";

export default {
  components: {
    TaskCard  
  },
  data() {
    return {
      pageCurrent: 1,
      firstLoadDone: false
      // tasks: []
    };
  },
  watch: {
    pageCurrent: {
        immediate: true,
        handler(value) {
          if(this.firstLoadDone){
            this.change();
          }else{
            this.firstLoadDone = true;
          }
        }
    },
  },
  computed: {
    ...mapGetters({
      getTasks: "getTasks",
      loading: "getLoading"
    }),
    tasks() {
      return this.getTasks ? this.getTasks.content : [];
    }
  },
  methods: {
    ...mapActions({
      actionGetTasks: "actionGetTasks"
    }),
    change() {
      this.actionGetTasks({ pageNumber: this.pageCurrent - 1, pageSize: 8 });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../assets/styles/main";

</style>
